<template>
  <div class="about">
    <h1>Blog</h1>
  </div>
</template>
